// Copyright (c) Move Closer 2022.

import { Methods, ResourcesRegistry } from '@movecloser/front-core'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const resources: ResourcesRegistry = {
  me: {
    connection: 'api',
    prefix: 'me',
    methods: {
      subscriptions: {
        url: 'subscriptions',
        method: Methods.Get
      }
    }
  }
}
